import React from "react";
import PropTypes from "prop-types";
import InputLabel from "components/v3/input-label/InputLabel";
import styles from "./styles.module.scss";

class TextInput extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showErrors: props.showErrors
        };

        this.nameForId = props.name.toLowerCase().split(" ").join("-");
        this._handleChange = this._handleChange.bind(this);
        this._handleFocus = this._handleFocus.bind(this);
        this._handleBlur = this._handleBlur.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.type !== this.props.type) {
            this.input.focus();
        }
    }

    componentDidMount() {
        if (this.props.disablePaste) {
            this.input.addEventListener("paste", disablePaste, false);
        }
    }

    componentWillUnmount() {
        if (this.props.disablePaste) {
            this.input.removeEventListener("paste", disablePaste, false);
        }
    }

    _handleFocus(event) {
        this.props.onFocus && this.props.onFocus(event);
    }

    _handleChange(event) {
        this.setState({
            showErrors: false
        });
        this.props.onChange && this.props.onChange(event);
    }

    _handleBlur(event) {
        this.setState({
            showErrors: true
        });
        this.props.onBlur && this.props.onBlur(event);
    }

    render() {
        const {
            name,
            label = name,
            type = "text",
            placeholder,
            value = "",
            error = {},
            autoFocus,
            disabled,
            optional = false,
            maxLength = "254"
        } = this.props;

        const { showErrors } = this.state;
        const errorMessage = showErrors ? error.message : "";
        const errorClass = !showErrors || !errorMessage ? "" : styles.error;
        const optionalClass = optional ? styles.optional : "";
        const disabledClass = disabled ? styles.disabled : "";
        const className = `${ styles.textInput } ${ errorClass } ${ disabledClass } ${ optionalClass }`;
        const showLabel = value || errorMessage;
        const errorLabelId = `${ this.nameForId }-error`;

        return (
            <div className={ className }>
                { showLabel
                    && (
                        <Label
                            name={ this.nameForId }
                            label={ label }
                            errorMessage={ errorMessage }
                            errorLabelId={ errorLabelId }
                        />
                    )
                }
                { optional && <Optional /> }
                <input
                    id={ `form-element-${ this.nameForId }` }
                    aria-required="true"
                    aria-invalid={ !!errorMessage }
                    aria-describedby={ errorLabelId }
                    aria-label={ name }
                    name={ name }
                    type={ type }
                    placeholder={ placeholder }
                    className={ styles.input }
                    maxLength={ maxLength }
                    value={ value }
                    disabled={ disabled }
                    onChange={ this._handleChange }
                    onBlur={ this._handleBlur }
                    onFocus={ this._handleFocus }
                    autoFocus={ autoFocus }
                    ref={ (input) => {
                        this.input = input;
                    } }
                />
            </div>
        );
    }
}

const Optional = () => {
    return (
        <div className={ styles.optionalLabel }>
            Optional
        </div>
    );
};

const Label = ({ name, label, errorMessage, errorLabelId }) => {
    const labelClassName = [
        styles.inputLabel,
        errorMessage && styles.inputLabelError
    ].filter((el) => el).join(" ");

    return (
        <div className={ labelClassName }>
            <InputLabel name={ name } label={ label } errorMessage={ errorMessage } errorLabelId={ errorLabelId } />
        </div>
    );
};

function disablePaste(event) {
    event.preventDefault();
}

TextInput.propTypes = {
    name: PropTypes.string,
    type: PropTypes.string,
    placeholder: PropTypes.string,
    maxLength: PropTypes.string,
    value: PropTypes.string,
    error: PropTypes.object,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    onFocus: PropTypes.func,
    autoFocus: PropTypes.bool,
    disabled: PropTypes.bool,
    disablePaste: PropTypes.bool,
    optional: PropTypes.bool
};

export { Label };
export default TextInput;
